export enum DashboardVariantEnum {
    KYC = 'KYC',
    KYT = 'KYT',
    DEEPFAKE = 'DEEPFAKE',
}
